<template>
  <div class="change-booking-summary">
    <h2 v-if="!this.success"> Zusammenfassung </h2>
    <h2 v-else> Danke für deine Buchung </h2>
    <ListOptionsDetails :item-list="[refactoredItem]" :show-header="true" :show-summary="true"></ListOptionsDetails>
    <Stepper
      @prev="back()"
      @next="save()"
      :loading-next="loading"
      :show-next="!this.success"
    >
      <template v-for="slot in possibleChildSlotsFor(this.childSlotName)" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>

import slotProxy from '@/mixins/slotProxy'
import Stepper from '@/components/generic/Stepper.vue'
import { mapActions, mapGetters } from 'vuex'
import ListOptionsDetails from '@/components/process/generic/Tariff/fyve/ListOptionsDetails.vue'

export default {
  name: 'TariffoptionChangeBooking',
  components: { Stepper, ListOptionsDetails },
  mixins: [slotProxy()],
  data () {
    return {
      loading: false,
      success: false,
      reload: false,
      refactoredItem: {},
      childSlotName: 'Stepper'
    }
  },
  created: function () {
    this.$store.commit('tariffs/resetState')
    this.$store.commit('bookTariffOptions/resetState')
    this.refactoredItem = this.item
    this.loading = true
    if (this.selected.key === 'Smart') {
      this.changeTariff({ tariffId: this.selected.id }).then(() => {
        this.loading = false
      }, () => {
        this.loading = false
      })
    } else if (this.selected.key === 'Service') {
      this.loading = false
    } else {
      this.bookTariffoption({ tariffoptionId: this.selected.id }).then(() => {
        this.loading = false
      }, () => {
        this.loading = false
      })
    }
  },
  computed: {
    ...mapGetters('tariffs', [
      'getContractUrl'
    ])
  },
  methods: {
    ...mapActions('tariffs', [
      'changeTariff',
      'confirmChangeTariff',
      'saveSelectedOptions'
    ]),
    ...mapActions('bookTariffOptions', [
      'bookTariffoption',
      'confirmTariffoption'
    ]),
    back () {
      this.$emit('view', { key: this.selected.key, back: false, reload: this.reload })
    },
    successResult () {
      this.childSlotName = 'StepperOverview'
      this.success = true
      this.reload = true
      this.$store.commit('tariffs/forceUpdate', true)
    },
    async save () {
      this.loading = true
      if (this.selected.key === 'Smart') {
        await this.confirmChangeTariff().then(() => {
          this.loading = false
          this.successResult()
        }, () => {
          this.loading = false
        })
      } else if (this.selected.key === 'Service') {
        await this.saveSelectedOptions({ value: true }).then(() => {
          this.loading = false
          this.successResult()
        }, () => {
          this.loading = false
        })
      } else {
        await this.confirmTariffoption().then(() => {
          this.loading = false
          this.successResult()
        }, () => {
          this.loading = false
        })
      }
    }
  },
  props: {
    selected: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
